import styled, { css } from 'styled-components'
import {
  typographyCss,
  TypographyCssProps,
  TypographyProps,
  TypographyWeights,
} from '../typography'

type TextWeights = {
  1: 'bold' | 'medium' | 'regular'
  1.5: 'bold' | 'medium' | 'regular'
  2: 'medium'
}
export type TextLevel = 1 | 1.5 | 2

export interface TextProps<Level extends TextLevel>
  extends TypographyProps<Level> {
  level?: Level
  weight?: TextWeights[Level]
}

export const fontSizes = {
  1: css<{ $weight?: TypographyWeights }>`
    font-size: 16px;
    line-height: 24px;
    font-weight: ${({ theme, $weight: weight = 'regular' }) =>
      theme.font.weight[weight]};

    ${({ theme }) => theme.mediaQueries.mobileDown} {
      font-size: 14px;
      line-height: 16px;
    }
  `,

  1.5: css<{ $weight?: TypographyWeights }>`
    font-size: 14px;
    line-height: 16px;
    font-weight: ${({ theme, $weight: weight = 'regular' }) =>
      theme.font.weight[weight]};
  `,

  2: css<{ $weight?: TypographyWeights }>`
    font-size: 12px;
    line-height: 16px;
    font-weight: ${({ theme, $weight: weight = 'medium' }) =>
      theme.font.weight[weight]};

    ${({ theme }) => theme.mediaQueries.mobileDown} {
      font-size: 12px;
      line-height: 16px;
    }
  `,
}

const Text = <Level extends TextLevel = TextLevel>(props: TextProps<Level>) => {
  const { children, level = 1, weight, ...restProps } = props

  return (
    <StyledText $level={level} $weight={weight} {...restProps}>
      {children}
    </StyledText>
  )
}

const StyledText = styled.div<TypographyCssProps & { $level: TextLevel }>`
  ${typographyCss}

  ${({ $level }) => fontSizes[$level]}
`

export default Text
